<template>
  <div v-if="showThis || !hideable">
    <custom-modal v-if="popupVisible" modal-width="27rem" @close="closeModal">
      <template #body>
        <div class="kk-subscribe-ad--title">
          <custom-icon class-name="icon-crown" icon-color="white" />
          <span>{{ $t("subscribead.title") }}</span>
        </div>

        <div class="px-4 py-4">
          <i18n-t keypath="subscribead.note" tag="p" scope="global">
            <template #needAwsMarketplaceAccount>
              <b>{{ $t("subscribead.needAwsMarketplaceAccount") }}</b>
            </template>
            <template #viewKyraOnAwsMarketplace>
              <br />
              <a :href="awsmpAppLink">
                {{ $t("subscribead.viewKyraOnAwsMarketplace") }}
              </a>
            </template>
          </i18n-t>
          <custom-button button-class="btn btn-default btn-block" @click="popupVisible = false">
            <custom-icon class-name="icon-close" icon-color="inherit" />
            {{ $t("actions.cancel") }}
          </custom-button>
        </div>
      </template>
    </custom-modal>

    <span @click="popupVisible = true">
      {{ $t("subscribead.subscribeBtn") }}
      <i class="icon-crown"></i>
    </span>

    <span v-if="hideable" class="kk-subscribe-ad__hide-ad-btn" @click="hideThis">
      {{ $t("subscribead.hideThisLink") }}
    </span>
  </div>
</template>

<script>
import CustomModal from "./commons/CustomModal.vue";
import CustomIcon from "./commons/CustomIcon.vue";
import CustomButton from "./commons/CustomButton.vue";

export default {
  components: { CustomModal, CustomIcon, CustomButton },
  props: {
    // added because hide btn is not needed when this component is used in profile
    hideable: {
      default: true,
      type: Boolean,
    },
    position: {
      default: "absolute",
      type: String,
    },
  },
  data() {
    return {
      // subscribe dialog having aws link
      popupVisible: false,
      awsmpAppLink: this.$t(`subscribead.awsmpAppLink.${process.env.VUE_APP_AWS_MP_APP}`),
    };
  },
  computed: {
    // subscribe btn shown on bottom left corner
    showThis() {
      return !this.$store.state.subscribePopupHidden;
    },
  },
  methods: {
    hideThis() {
      this.$store.dispatch("setSubscribePopupHidden", true);
    },
  },
};
</script>

<style lang="less" scoped>
@import "../assets/styles/variables";
.kk-subscribe-ad {
  &--title {
    height: 64px;
    background-color: #1976d2;
    display: flex;
    align-items: center;
    gap: 1rem;
    padding-left: 1rem;
    color: white;
    font-size: 1.5rem;
  }

  &__hide-ad-btn {
    text-align: right;
    margin-top: 0.25rem;
    color: @kk-color-gray;
    font-size: 0.75rem;
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>
